var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccuracy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 905,
    viewBox: "0 0 905 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 905,
    height: 905,
    rx: 160,
    fill: "#3B82F6",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 741,
    height: 741,
    rx: 100,
    fill: "#3B82F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.844 452C543.844 502.724 502.724 543.844 452 543.844C401.276 543.844 360.156 502.724 360.156 452C360.156 401.276 401.276 360.156 452 360.156C502.724 360.156 543.844 401.276 543.844 452ZM476.169 298.784C542.376 309.188 594.812 361.624 605.216 427.83H654C642.953 334.933 569.067 261.048 476.169 250V298.784ZM298.784 427.831C309.188 361.624 361.623 309.188 427.83 298.784V250C334.932 261.047 261.048 334.933 250 427.831H298.784ZM605.216 476.169C594.812 542.377 542.376 594.812 476.169 605.217V654C569.067 642.953 642.953 569.067 654 476.169H605.216ZM427.831 605.217C361.623 594.812 309.188 542.376 298.784 476.169H250C261.047 569.067 334.932 642.953 427.831 654V605.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 429.5L423.403 508L543 363",
    stroke: "#3B82F6",
    strokeWidth: 32
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 404,
    fill: "white",
    transform: "translate(250 250)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracy);
export default __webpack_public_path__ + "static/media/accuracy.ac340b62e8533f8b62764a95a80a9022.svg";
export { ForwardRef as ReactComponent };